import { passIsGood } from '../../validators/password';

export function generatePassword(length: number = 12): string {
  const symbols = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!?@#$%^&*_-~<>/|0123456789';
  let password = '';
  for (let i = 0; i < length; i++) {
    password += symbols.charAt(Math.floor(Math.random() * symbols.length));
  }
  if (!passIsGood(password)) {
    return generatePassword();
  }
  return password;
}
